import { styled } from 'styled-components';
import { Typography } from '@altibox/design-system-component-lib';

import { spacing1, spacing5, spacing6 } from 'src/styles/spacing';
import { breakpointTablet } from 'src/styles/breakpoints';

export const StyledContainer = styled.div`
  margin-top: ${spacing5};

  @media (min-width: ${breakpointTablet}) {
    margin-top: ${spacing6};
  }
`;

export const StyledLabel = styled(Typography)`
  margin-bottom: ${spacing1};
  font-weight: bold;
  display: none;

  @media (min-width: ${breakpointTablet}) {
    display: initial;
  }
`;

export const StyledVideoContainer = styled.div`
  display: flex;
  gap: ${spacing6};
`;
